import React, { Component } from "react";
import { Form, Button, Icon, Table, Modal, Input, Select, Checkbox, Upload, DatePicker, message, Tooltip } from "antd";
import moment from 'moment';
import "./settingUser.scss";
import axios from 'axios'
import { getAffiliatedHospitelList, getRoleList, userSelect, deleteUser, addUser, hospitalMenuData, deptSelect } from '@/request/api'
import { requestErrorLog } from '@/common/util'
const { TextArea } = Input;
const { Option } = Select;
const { confirm } = Modal;

class SettingUser extends Component {
  constructor(props) {
    super(props);
    this.state = {
      hospitalData: [],
      userHosDept: [],
      RoleMenuList: [],
      userRoleList: [],
      currentHospital: {},
      tableList: [],
      rowData: "",
      signatureUrl: '',
      checked: true,
      custServiceChecked: false,
      // loginCode: '',
      // realName: '',
      queryInfoValue: '',
      PageNo: 1,
      PageSize: 10,
      RowCount: 0,
      file: {},
      userColumns: [
        {
          title: "登录账号",
          dataIndex: "LOGIN_CODE",
          key: "LOGIN_CODE",
          width: 90,
          render: (text) => {
            return (
              <Tooltip placement="topLeft" title={text}>
                <span>{text}</span>
              </Tooltip>
            )
          }
        },
        {
          title: "HIS工号",
          dataIndex: "USER_HIS_CODE",
          key: "USER_HIS_CODE",
          width: 120,
        },
        {
          title: "所属医院",
          dataIndex: "HOSPITAL_UID",
          key: "HOSPITAL_UID",
          width: 170,
          render: (text) => {
            return this.state.hospitalData.map((item, index) => {
              const a = item.HOSPITAL_UID === text ? item.HOSPITAL_NAME : null
              return <Tooltip placement="topLeft" title={a}> <span>{a}</span></Tooltip>
            });
          }
        },
        {
          title: "所属科室",
          dataIndex: "DEPT_NAME",
          key: "DEPT_NAME",
          width: 170
        },
        {
          title: "姓名",
          dataIndex: "REAL_NAME",
          key: "REAL_NAME",
          width: 120,
        },
        {
          title: "用户角色",
          dataIndex: "ROLE_NAME",
          key: "ROLE_NAME",
          align: 'center',
          width: 160,
          ellipsis: true,
          render: (text) => {
            return (
              <Tooltip placement="topLeft" title={text}>
                <span>{text}</span>
              </Tooltip>
            )
          }
        },
        {
          title: "医院权限",
          dataIndex: "MENU_NAME",
          key: "MENU_NAME",
          align: 'center',
          width: 160,
          ellipsis: true,
          render: (text) => {
            return (
              <Tooltip placement="topLeft" title={text}>
                <span>{text}</span>
              </Tooltip>
            )
          }
        },
        {
          title: "有效",
          dataIndex: "IS_ENABLED",
          key: "IS_ENABLED",
          width: 90,
          render: (text) => {
            return text ? "是" : "否";
          },
        },
        {
          title: "手机号码",
          dataIndex: "TELEPHONE",
          key: "TELEPHONE",
          width: 150,
        },
      ],
    };
  }

  componentDidMount() {
    let userInfo = JSON.parse(localStorage.getItem('userInfo')) || {}
    this.userList()     // 用户列表
    this.hospitalList() // 医院列表
    this.userRoleList() // 角色列表
    this.hospitalMenuList(userInfo.HOSPITAL_CODE) // 菜单列表
  }

  hospitalList = () => { // 获取医院列表
    getAffiliatedHospitelList().then((res) => {
      if (res && res.Status === 1) {
        const data = res.Result
        this.setState({
          hospitalData: data,
        })
      } else {
        requestErrorLog('', '权限管理-用户管理-获取医院列表报错', 0, true)
      }
    })
  }

  // 切换医院时 科室清空
  changeHosToDept = (value, option) => {
    this.props.form.setFieldsValue({
      "DEPT_UID": undefined,
      "QUERY_ALL": undefined,
      "ROLE_NAME": undefined
    });
    let obj = this.state.hospitalData.filter(item => item.HOSPITAL_UID === option.key)[0]
    if (obj.HOSPITAL_CODE !== 'PLATFORM') {
      this.setState({
        custServiceChecked: false,
      })
    }
    this.setState({
      currentHospital: {
        HOSPITAL_NAME: obj.HOSPITAL_NAME,
        HOSPITAL_UID: obj.HOSPITAL_UID,
        HOSPITAL_CODE: obj.HOSPITAL_CODE,
      },
    })
    this.hospitalMenuList(obj.HOSPITAL_CODE)
    this.handleSelectUserHos(value, option.key);
    this.userRoleList(obj.HOSPITAL_CODE)
  }

  handleSelectUserHos = (value, option) => { // 获取系统科室
    let params = {
      "Type": "DeptSelect",
      "HOSPITAL_UID": option
    }
    deptSelect(params).then((res) => {
      if (res && res.Status === 1) {
        const data = res.Result;
        this.setState({
          userHosDept: data
        })
      } else {
        requestErrorLog('', '权限管理-用户管理-获取系统科室报错', 0, true)
      }
    })
  }

  userRoleList = (hospital_Code) => { // 获取用户角色列表
    getRoleList().then((res) => {
      if (res && res.Status === 1) {
        const userRoleData = res.Result
        let userRoleList = [];
        if (userRoleList.length === 1 && !userRoleList[0].Menu_Name) {
          userRoleList = [];
        } else {
          // 非管理员进入过滤二级管理员
          if (hospital_Code !== 'PLATFORM') {
            userRoleList = userRoleData
              .filter(item => item.ROLE_NAME !== '二级管理员')
              .map(item => ({
                label: item.ROLE_NAME,
                value: item.ROLE_UID
              }));
          } else {
            userRoleList = userRoleData
              .map(item => ({
                label: item.ROLE_NAME,
                value: item.ROLE_UID
              }));
          }
          // userRoleData.forEach(item => {
          //   userRoleList.push({ label: item.ROLE_NAME, value: item.ROLE_UID })
          // })
        }
        this.setState({ userRoleList, })
      } else {
        requestErrorLog('', '权限管理-用户管理-获取用户角色列表报错', 0, true)
      }
    })
  }

  hospitalMenuList = (HOSPITAL_CODE) => {// 医院权限列表
    let params = {
      "Type": "HospitalMenuData",
      "HOSPITAL_CODE": HOSPITAL_CODE,
    }
    hospitalMenuData(params).then((res) => {
      if (res && res.Status === 1) {
        const MenuList = res.Result
        let RoleMenuList = [];
        if (MenuList.length === 1 && !MenuList[0].Menu_Name) {
          RoleMenuList = [];
        } else {
          // 非管理员进入过滤二级管理员
          // if (HOSPITAL_CODE !== 'PLATFORM') {
          //   RoleMenuList = MenuList
          //     .filter(item => item.Menu_Name !== '权限管理')
          //     .map(item => ({
          //       label: item.Menu_Name,
          //       value: item.Menu_Uid
          //     }));
          // } else {
          //   RoleMenuList = MenuList
          //     .map(item => ({
          //       label: item.Menu_Name,
          //       value: item.Menu_Uid
          //     }));
          // }
          MenuList.forEach(item => {
            RoleMenuList.push({ label: item.Menu_Name, value: item.Menu_Uid })
          })
        }
        this.setState({
          RoleMenuList,
        })
      } else {
        requestErrorLog('', '权限管理-用户管理-获取医院权限列表报错', 0, true)
      }
    })
  }

  userList = () => { // 获取用户列表
    let userInfo = JSON.parse(localStorage.getItem('userInfo')) || {}
    let params = {
      Type: "USER_SELECT",
      HOSPITAL_UID: userInfo.HOSPITAL_UID,
      // LOGIN_CODE: this.state.loginCode,
      // USER_NAME: this.state.realName,
      PageNo: this.state.PageNo,
      PageSize: this.state.PageSize,
      searchValue: this.state.queryInfoValue,
      USER_UID: userInfo.USER_UID
    }
    userSelect(params).then((res) => {
      if (res && res.Status === 1) {
        const dataList = res.Result.dataInfo
        let RowCount = res.Result.pageInfo.RowCount
        this.setState({
          tableList: dataList,
          RowCount
        })
      } else {
        requestErrorLog('', '权限管理-用户管理-获取用户列表报错', 0, true)
      }
    })
  }

  handleUserAdd = () => { // 新增
    this.props.form.resetFields(); //清空form中每条数据
    const userInfo = JSON.parse(localStorage.getItem('userInfo')) || ""
    this.setState({
      isModalVisible: true,
      modalTitle: "USER_ADD",
      rowData: "",
      currentHospital: {
        HOSPITAL_NAME: userInfo.HOSPITAL_NAME,
        HOSPITAL_UID: userInfo.HOSPITAL_UID,
        HOSPITAL_CODE: userInfo.HOSPITAL_CODE,
      },
    }, () => {
      // this.props.form.setFieldsValue({
      //   "HOSPITAL_NAME": this.state.currentHospital.HOSPITAL_NAME
      // });
      this.userRoleList()
      this.handleSelectUserHos(null, this.state.currentHospital.HOSPITAL_UID)
      this.hospitalMenuList(this.state.currentHospital.HOSPITAL_CODE)
    });
  };

  handleUserEdit = () => { // 修改
    this.props.form.resetFields(); //清空form中每条数据
    const { rowData } = this.state;
    let powerMenuId = [] //角色信息
    let roleMenuId = [] //用户信息
    if (rowData) {
      if (rowData.ROLE_UID && !Array.isArray(rowData.ROLE_UID)) {//角色权限
        rowData.ROLE_UID = rowData.ROLE_UID.split(',')
      }
      if (rowData.MENU_UID && !Array.isArray(rowData.MENU_UID)) { //菜单权限
        rowData.MENU_UID = rowData.MENU_UID.split(',')
      }
      if (rowData.ROLE_UID) {
        powerMenuId = rowData?.ROLE_UID.map((item) => {
          return { ROLE_UID: item }
        })
      }
      if (rowData.MENU_UID) {
        roleMenuId = rowData?.MENU_UID.map((item) => {
          return { PRIVILEGE_UID: item }
        })
      }
      this.setState({
        isModalVisible: true,
        modalTitle: "USER_EDIT",
        checked: rowData.IS_ENABLED,
        custServiceChecked: rowData.QUERY_ALL,
        rowData,
        roleMenu: roleMenuId,
        powerMenu: powerMenuId,
        currentHospital: {
          HOSPITAL_NAME: rowData.HOSPITAL_NAME,
          HOSPITAL_UID: rowData.HOSPITAL_UID,
          HOSPITAL_CODE: rowData.HOSPITAL_CODE,
        },
        signatureUrl: rowData.SIGNATURE_NAME ? window.g.baseURL + '/' + rowData.SIGNATURE_NAME + '?' + Math.random() : ''
      }, () => {
        this.props.form.setFieldsValue({
          "HOSPITAL_NAME": this.state.currentHospital.HOSPITAL_NAME
        });
        this.handleSelectUserHos(null, rowData.HOSPITAL_UID)
        this.hospitalMenuList(this.state.currentHospital.HOSPITAL_CODE)
        this.userRoleList(this.state.currentHospital.HOSPITAL_CODE)
      });
    } else {
      message.warning('请先选择要操作的数据');
    }
  };

  handleUserDelete = () => { // 删除
    const userInfo = JSON.parse(localStorage.getItem('userInfo')) || {}
    if (!this.state.rowData) {
      message.warning('请先选择要操作的数据');
    } else {
      confirm({
        title: '删除操作',
        content: '确认删除该用户吗？',
        onOk: () => {
          let params = {
            Type: "DELETE",
            USER_UID: this.state.rowData.USER_UID,
            OPERATOR_UID: userInfo.USER_UID
          }
          deleteUser(params).then((res) => {
            if (res && res.Status === 1) {
              if (res.Result === -1) {
                message.error('用户不存在！');
                return;
              }
              if (res.Result === -2) {
                message.error('编辑人与添加人需一致！');
                return;
              }
              message.success("删除成功！")
              this.setState({ rowData: '' })
              this.userList()
            } else {
              requestErrorLog('', '权限管理-用户管理-删除用户报错', 0, true)
              message.error("删除失败！")
            }
          })
        },
      });
    }
  };

  handleUserSubmit = () => {
    const { modalTitle, checked, rowData, roleMenu, powerMenu, currentHospital, custServiceChecked } = this.state
    const userInfo = JSON.parse(localStorage.getItem('userInfo')) || ""
    this.props.form.validateFields((err, values) => {
      if (!err) {
        let Param = {
          Type: modalTitle,
          HOSPITAL_CODE: currentHospital.HOSPITAL_CODE,
        }
        let RequestModel = {};
        RequestModel = {
          userinfo: {
            USER_UID: modalTitle === 'USER_EDIT' ? rowData.USER_UID : '',
            DEPT_UID: values.DEPT_UID,   //所在科室
            LOGIN_CODE: values.LOGIN_CODE,   //登录账号
            REAL_NAME: values.REAL_NAME,   //姓名
            USER_HIS_CODE: values.HIS_CODE,  //his工号
            PASSWORD: values.PASSWORD === '********' ? rowData.PASSWORD : values.PASSWORD, //密码
            IS_ENABLED: checked ? 1 : 0,  // 是否有效（1有效）
            EMAIL: values.EMAIL, //电子邮件
            TELEPHONE: values.TELEPHONE,  //手机
            TITLE: values.TITLE,  //职称
            SEX: values.SEX,  //姓别
            BIRTHDAY: values.BIRTHDAY, //生日
            HOME_ADDRESS: values.HOME_ADDRESS, //家庭住址
            DESCRIPTION: values.DESCRIPTION,  //描述
            HOSPITAL_UID: currentHospital.HOSPITAL_UID,  //所在医院
            SIGNATURE_NAME: modalTitle === 'USER_EDIT' ? rowData.SIGNATURE_NAME : '',  //电子签名
            QUERY_ALL: custServiceChecked ? 1 : 0,  //(客服权限1，反之为0)
          },
          user_Privilege: powerMenu || [], // 角色信息
          user_menu: roleMenu || [] // 菜单信息
        }
        if (modalTitle === 'USER_ADD') {
          RequestModel.userinfo.CREATE_UID = userInfo.USER_UID;
        }
        if (modalTitle === 'USER_EDIT') {
          RequestModel.userinfo.EDIT_UID = userInfo.USER_UID;
        }
        addUser(Param, RequestModel).then((res) => {
          if (res && res.Status === 1) {
            if (res.Result === -2) {
              message.error('登录账号已存在！');
              return;
            }
            if (res.Result === -3) {
              message.error('编辑人与添加人需一致！');
              return;
            }
            if (res.Result === -4) {
              message.error('不存在该数据！');
              return;
            }
            this.setState({
              isModalVisible: false,
              powerMenu: [],
              roleMenu: [],
              IS_ENABLED: true,
              rowData: ''
            })
            modalTitle === 'USER_ADD' ? message.success("新建成功") : message.success("修改成功")
            if (Object.keys(this.state.file).length > 0) {
              modalTitle === 'USER_ADD' ?
                this.uploadSignatureFn(res.Result.USER_UID) :
                this.uploadSignatureFn(rowData.USER_UID)
            } else {
              this.userList()
            }
          } else {
            requestErrorLog('', '权限管理-用户管理-' + modalTitle === 'USER_ADD' ? '新建用户报错' : '编辑用户报错', 0, true)
            modalTitle === 'USER_ADD' ? message.error("新建失败！") : message.error("修改失败！")
          }
        });

      }
    })
  }

  onClickRow = (record) => {
    return {
      onClick: () => {
        this.setState({
          rowData: record,
        });
      },
    };
  };

  setRowClassName = (record) => {
    return record === this.state.rowData ? "clickRowStyl" : "";
  };

  handleCancel = () => {
    this.setState({
      isModalVisible: false,
      checked: true,
      custServiceChecked: false,
      roleMenu: [],
      powerMenu: [],
      file: {},
      signatureUrl: '',
      currentHospital: {
        HOSPITAL_NAME: '',
        HOSPITAL_UID: '',
        HOSPITAL_CODE: '',
      }
    });
  };

  onAddCheckbox = (value) => {
    let checkedFlag = value.target.checked
    this.setState({
      checked: checkedFlag
    })
  }

  onCustomerService = (value) => {
    let custServiceFlag = value.target.checked
    this.setState({
      custServiceChecked: custServiceFlag
    })
  }

  handleHospitalValue = (checkedValues) => { // 菜单权限
    const { RoleMenuList } = this.state;
    const RoleMenu = []
    RoleMenuList.forEach(item => {
      if (checkedValues.indexOf(item.value) > -1) {
        RoleMenu.push({ "PRIVILEGE_UID": item.value })
      }
    })
    this.setState({
      roleMenu: RoleMenu
    })
  }

  handleRolePowerValue = (checkedValues) => { // 用户角色
    const { userRoleList } = this.state;
    const PowerMenu = []
    userRoleList.forEach(item => {
      if (checkedValues.indexOf(item.value) > -1) {
        PowerMenu.push({ "ROLE_UID": item.value })
      }
    })
    this.setState({
      powerMenu: PowerMenu
    })
  }

  //密码框获取焦点时清空输入框
  passwordFocus = () => {
    this.props.form.setFieldsValue({
      "PASSWORD": null
    });
  }
  beforeUpload = (file) => {
    const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
    if (!isJpgOrPng) {
      message.error('请选择JPG或者PNG格式图片');
      return false;
    }
    const isLt2M = file.size / 1024 / 1024 < 2;
    if (!isLt2M) {
      message.error('图片不能大于2M');
      return false;
    }
    let url = window.URL ? window.URL.createObjectURL(file) : window.webkitURL.createObjectURL(file);
    this.setState({
      signatureUrl: url,
      file,
    })
    return false;
  }
  uploadSignatureFn = (USER_UID) => {
    let formData = new FormData();
    formData.append('file', this.state.file)
    let config = { headers: { 'Content-Type': 'multipart/form-data' } }
    let url = window.g.baseURL + "/api/UploadSignaturePicture?strUserUID=" + USER_UID;
    axios.post(url, formData, config).then(res => {
      if (res.data.Status === 1) {
        this.userList()
      }
      this.setState({
        file: {},
        signatureUrl: ''
      })
    }).catch(err => {
      requestErrorLog('', '权限管理-用户编辑报错：' + JSON.stringify(url + formData), 0, false)
    });
  }
  handleQueryUserInfo = (e) => {
    this.setState({
      queryInfoValue: e.target.value
    })
  }
  //筛选
  // handleLoginCode = (e) => {
  //   this.setState({
  //     loginCode: e.target.value,
  //   })

  // }
  // handleRealName = (e) => {
  //   this.setState({
  //     realName: e.target.value
  //   })
  // }
  handleRoleList = () => {
    this.setState({
      PageNo: 1,
      PageSize: 10,
    }, () => {
      this.userList()
    })
  }
  changeFocus = (e) => {
    if (e.keyCode === 13) {
      this.handleRoleList();
    }
  }
  changePageFn = PageNo => {
    this.setState({
      PageNo
    }, () => {
      this.userList()
    })
  }
  render() {
    const { getFieldDecorator } = this.props.form;
    const { isModalVisible, modalTitle, userColumns, RoleMenuList, tableList, userRoleList, rowData, hospitalData, custServiceChecked, currentHospital } = this.state;
    const userInfo = JSON.parse(localStorage.getItem('userInfo')) || {}
    const roleList = JSON.parse(localStorage.getItem('roleList')) || {}
    return (
      <>
        <div className="btnStyle" style={{ marginBottom: "10px" }}>
          <Button onClick={this.handleUserAdd}>
            <Icon type="plus-circle" />
            添加
          </Button>
          <Button onClick={() => this.handleUserEdit()}>
            <Icon type="minus-circle" />
            修改
          </Button>
          <Button onClick={this.handleUserDelete}>
            <Icon type="close-circle" />
            删除
          </Button>
        </div>
        <Form layout="inline" className="searchBox">
          {/* <Form.Item label="登录账号">
            <Input allowClear value={this.state.loginCode} onChange={this.handleLoginCode} onKeyUp={this.changeFocus} />
          </Form.Item>
          <Form.Item label="姓名">
            <Input allowClear value={this.state.realName} onChange={this.handleRealName} onKeyUp={this.changeFocus} />
          </Form.Item> */}
          <Form.Item label="信息查询">
            <Input
              allowClear
              value={this.state.queryInfoValue}
              onChange={this.handleQueryUserInfo}
              onKeyUp={this.changeFocus}
            />
          </Form.Item>
          <Button onClick={this.handleRoleList}>查询</Button>
        </Form>
        <Table
          columns={userColumns}
          dataSource={tableList}
          rowKey={(record) => record.USER_UID}
          pagination={{
            total: this.state.RowCount,
            current: this.state.PageNo,
            onChange: this.changePageFn
          }}
          onRow={this.onClickRow}
          rowClassName={this.setRowClassName}
        />
        {isModalVisible ?
          <Modal
            width={600}
            title={
              <div className="patient_title">
                <img alt="" src={require("@/assets/image/ecg.png").default} className="addIcon" />
                <span>{modalTitle === "USER_ADD" ? "添加用户" : "编辑用户"}</span>
              </div>
            }
            visible={isModalVisible}
            maskClosable={false}
            onOk={this.handleUserSubmit}
            onCancel={this.handleCancel}
          >
            <Form
              layout="inline"
              className="settingUserWrap settingComponentWrap checkWrap settingSignature"
            >
              <input type="password" className="fake-input" /> {/* 解决浏览器记住密码覆盖输入框问题 */}
              <input type="text" className="fake-input" />
              <Form.Item label="登录账号" className="settingHospitalRequire">
                {getFieldDecorator("LOGIN_CODE", { initialValue: rowData.LOGIN_CODE, rules: [{ required: true, message: '请输入您的登录账号' }] })(<Input allowClear={true} />)}
              </Form.Item>
              <Form.Item label="姓名" className="settingHospitalRequire">
                {getFieldDecorator("REAL_NAME", { initialValue: rowData.REAL_NAME, rules: [{ required: true, message: '请输入您的姓名' }] })(<Input allowClear={true} />)}
              </Form.Item>
              <Form.Item label="HIS工号">
                {getFieldDecorator("HIS_CODE", { initialValue: rowData.USER_HIS_CODE })(<Input allowClear={true} />)}
              </Form.Item>
              <Form.Item label="性别" className="settingHospitalRequire">
                {getFieldDecorator("SEX", { initialValue: rowData.SEX, rules: [{ required: true, message: '请输入您的性别' }] })(
                  <Select>
                    <Option value="M">男</Option>
                    <Option value="F">女</Option>
                    <Option value="U">未知</Option>
                    <Option value="W">未说明</Option>
                  </Select>
                )}
              </Form.Item>
              <Form.Item label="密码" className="settingHospitalRequire">
                {getFieldDecorator("PASSWORD", { initialValue: modalTitle === "USER_EDIT" ? '********' : '', rules: [{ required: true, message: '请输入您的密码' }] })(<Input onFocus={this.passwordFocus} type="password" allowClear={true} />)}
              </Form.Item>
              <Form.Item label="出生日期">
                {getFieldDecorator("BIRTHDAY", { initialValue: rowData.BIRTHDAY && moment(rowData.BIRTHDAY) })(
                  <DatePicker disabledDate={this.disabledDate} allowClear />
                )}
              </Form.Item>
              <Form.Item label="手机">
                {getFieldDecorator("TELEPHONE", { initialValue: rowData.TELEPHONE })(<Input allowClear={true} />)}
              </Form.Item>
              <Form.Item label="职称">
                {getFieldDecorator("TITLE", { initialValue: rowData.TITLE })(<Input allowClear={true} />)}
              </Form.Item>
              {userInfo.IS_ADMINISTRATOR === "1" || roleList.indexOf('二级管理员') > -1 ?
                <Form.Item label="所在医院" className="settingHospitalRequire">
                  {getFieldDecorator("HOSPITAL_NAME", { rules: [{ required: true, message: '请输入您所在的医院' }] })(
                    <Select
                      onChange={this.changeHosToDept}
                      showSearch
                      disabled={modalTitle === "USER_EDIT" ? true : false}
                      getPopupContainer={triggerNode => triggerNode.parentNode}
                    >
                      {hospitalData.map((item) => (
                        <Option key={item.HOSPITAL_UID} value={item.HOSPITAL_NAME}>{item.HOSPITAL_NAME}</Option>
                      ))}
                    </Select>
                  )}
                </Form.Item> : null
                // <Form.Item label="所在医院" className="settingHospitalRequire">
                //   {getFieldDecorator("HOSPITAL_NAME", { rules: [{ required: true, message: '请输入您所在的医院' }] })(
                //     <Input disabled />
                //   )}
                // </Form.Item>
              }

              <Form.Item label="所在科室" className="settingHospitalRequire">
                {getFieldDecorator("DEPT_UID", { initialValue: rowData.DEPT_UID, rules: [{ required: true, message: '请输入您所在的科室' }] })(
                  <Select placeholder="请选择科室" getPopupContainer={triggerNode => triggerNode.parentNode}>
                    {
                      this.state.userHosDept.map((item) => {
                        return <Option key={item.DEPT_UID} value={item.DEPT_UID}>{item.DEPT_NAME}</Option>
                      })
                    }
                  </Select>
                )}
              </Form.Item>
              <div className="lineBlock">
                <Form.Item label="家庭住址">
                  {getFieldDecorator("HOME_ADDRESS", { initialValue: rowData.HOME_ADDRESS })(<Input allowClear={true} />)}
                </Form.Item>
              </div>
              <div className="lineBlock">
                <Form.Item label="电子邮件">
                  {getFieldDecorator("EMAIL", { initialValue: rowData.EMAIL })(<Input allowClear={true} />)}
                </Form.Item>
              </div>
              <div className="lineBlock">
                <Form.Item label="是否有效">
                  {getFieldDecorator("IS_ENABLED", { valuePropName: 'checked', initialValue: modalTitle === 'USER_EDIT' ? rowData.IS_ENABLED : this.state.checked })(
                    <Checkbox onChange={this.onAddCheckbox}>有效</Checkbox>
                  )}
                </Form.Item>
              </div>
              <div className="lineBlock">
                <Form.Item label="描述">
                  {getFieldDecorator("DESCRIPTION", { initialValue: rowData.DESCRIPTION })(<TextArea rows={4} />)}
                </Form.Item>
              </div>
              <div className="lineBlock">
                <Form.Item label="用户角色" className="lineBlock">
                  {getFieldDecorator("ROLE_NAME", { initialValue: modalTitle === "USER_ADD" ? [] : rowData.ROLE_UID ? rowData.ROLE_UID : [], rules: [{ required: !custServiceChecked, message: '请选择用户角色！' }] })(
                    <Checkbox.Group
                      options={userRoleList}
                      onChange={this.handleRolePowerValue}
                    >
                    </Checkbox.Group>
                  )}
                </Form.Item>
              </div>
              <div className="lineBlock">
                <Form.Item label="菜单权限" className="lineBlock">
                  {getFieldDecorator("MENU_NAME", {
                    initialValue: modalTitle === "USER_ADD" ? [] : rowData.MENU_UID ? rowData.MENU_UID : [],
                    rules: [{ required: !custServiceChecked, message: '请选择菜单权限！' }]
                  })(
                    <Checkbox.Group
                      onChange={this.handleHospitalValue}
                      options={RoleMenuList}
                    >
                    </Checkbox.Group>
                  )}
                </Form.Item>
              </div>
              <div className="lineBlock">
                <Form.Item label="客服权限" >
                  {getFieldDecorator("QUERY_ALL", { valuePropName: 'checked', initialValue: modalTitle === 'USER_EDIT' ? custServiceChecked : '' })(
                    <Checkbox onChange={this.onCustomerService} disabled={currentHospital.HOSPITAL_CODE === 'PLATFORM' ? false : true}>有效</Checkbox>
                  )}
                </Form.Item>
              </div>
              <Form.Item label="签名">
                <div className="signature">
                  {this.state.signatureUrl ?
                    <img alt="" src={this.state.signatureUrl} /> : null
                  }
                </div>
                <Upload
                  beforeUpload={this.beforeUpload}
                  showUploadList={false}
                >
                  <Button style={{ color: "#fff" }}>选择签名</Button>
                </Upload>
              </Form.Item>
            </Form>
          </Modal> : null
        }

      </>
    );
  }
}

export default Form.create({})(SettingUser);
